import _toConsumableArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import $9Q8De$react, { useState as $9Q8De$useState, useImperativeHandle as $9Q8De$useImperativeHandle, Fragment as $9Q8De$Fragment } from "react";
import $9Q8De$reactdom from "react-dom";
import { VisuallyHidden as $9Q8De$VisuallyHidden } from "@react-aria/visually-hidden";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $319e236875307eab$exports = {};
$parcel$export($319e236875307eab$exports, "announce", function () {
  return $319e236875307eab$export$a9b970dcc4ae71a9;
});
$parcel$export($319e236875307eab$exports, "clearAnnouncer", function () {
  return $319e236875307eab$export$d10ae4f68404609a;
});
$parcel$export($319e236875307eab$exports, "destroyAnnouncer", function () {
  return $319e236875307eab$export$d8686216b8b81b2f;
});
/* Inspired by https://github.com/AlmeroSteyn/react-aria-live */

var $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
var $319e236875307eab$var$liveRegionAnnouncer = /*#__PURE__*/$9Q8De$react.createRef();
var $319e236875307eab$var$node = null;
var $319e236875307eab$var$messageId = 0;

function $319e236875307eab$export$a9b970dcc4ae71a9(message) {
  var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;
  $319e236875307eab$var$ensureInstance(function (announcer) {
    return announcer.announce(message, assertiveness, timeout);
  });
}

function $319e236875307eab$export$d10ae4f68404609a(assertiveness) {
  $319e236875307eab$var$ensureInstance(function (announcer) {
    return announcer.clear(assertiveness);
  });
}

function $319e236875307eab$export$d8686216b8b81b2f() {
  if ($319e236875307eab$var$liveRegionAnnouncer.current) {
    $9Q8De$reactdom.unmountComponentAtNode($319e236875307eab$var$node);
    document.body.removeChild($319e236875307eab$var$node);
    $319e236875307eab$var$node = null;
  }
}
/**
 * Ensures we only have one instance of the announcer so that we don't have elements competing.
 */


function $319e236875307eab$var$ensureInstance(callback) {
  if (!$319e236875307eab$var$liveRegionAnnouncer.current) {
    $319e236875307eab$var$node = document.createElement('div');
    $319e236875307eab$var$node.dataset.liveAnnouncer = 'true';
    document.body.prepend($319e236875307eab$var$node);
    $9Q8De$reactdom.render( /*#__PURE__*/$9Q8De$react.createElement($319e236875307eab$var$LiveRegionAnnouncer, {
      ref: $319e236875307eab$var$liveRegionAnnouncer
    }), $319e236875307eab$var$node, function () {
      return callback($319e236875307eab$var$liveRegionAnnouncer.current);
    });
  } else callback($319e236875307eab$var$liveRegionAnnouncer.current);
}

var $319e236875307eab$var$LiveRegionAnnouncer = /*#__PURE__*/$9Q8De$react.forwardRef(function (_, ref) {
  var _$9Q8De$useState = $9Q8De$useState([]),
      _$9Q8De$useState2 = _slicedToArray(_$9Q8De$useState, 2),
      assertiveMessages = _$9Q8De$useState2[0],
      setAssertiveMessages = _$9Q8De$useState2[1];

  var _$9Q8De$useState3 = $9Q8De$useState([]),
      _$9Q8De$useState4 = _slicedToArray(_$9Q8De$useState3, 2),
      politeMessages = _$9Q8De$useState4[0],
      setPoliteMessages = _$9Q8De$useState4[1];

  var clear = function clear(assertiveness) {
    if (!assertiveness || assertiveness === 'assertive') setAssertiveMessages([]);
    if (!assertiveness || assertiveness === 'polite') setPoliteMessages([]);
  };

  var $319e236875307eab$export$a9b970dcc4ae71a9 = function $319e236875307eab$export$a9b970dcc4ae71a9(message1) {
    var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;
    var id = $319e236875307eab$var$messageId++;
    if (assertiveness === 'assertive') setAssertiveMessages(function (messages) {
      return [].concat(_toConsumableArray(messages), [{
        id: id,
        text: message1
      }]);
    });else setPoliteMessages(function (messages) {
      return [].concat(_toConsumableArray(messages), [{
        id: id,
        text: message1
      }]);
    });
    if (message1 !== '') setTimeout(function () {
      if (assertiveness === 'assertive') setAssertiveMessages(function (messages) {
        return messages.filter(function (message) {
          return message.id !== id;
        });
      });else setPoliteMessages(function (messages) {
        return messages.filter(function (message) {
          return message.id !== id;
        });
      });
    }, timeout);
  };

  $9Q8De$useImperativeHandle(ref, function () {
    return {
      announce: $319e236875307eab$export$a9b970dcc4ae71a9,
      clear: clear
    };
  });
  return /*#__PURE__*/$9Q8De$react.createElement($9Q8De$Fragment, null, /*#__PURE__*/$9Q8De$react.createElement($319e236875307eab$var$MessageBlock, {
    "aria-live": "assertive"
  }, assertiveMessages.map(function (message) {
    return /*#__PURE__*/$9Q8De$react.createElement("div", {
      key: message.id
    }, message.text);
  })), /*#__PURE__*/$9Q8De$react.createElement($319e236875307eab$var$MessageBlock, {
    "aria-live": "polite"
  }, politeMessages.map(function (message) {
    return /*#__PURE__*/$9Q8De$react.createElement("div", {
      key: message.id
    }, message.text);
  })));
});

function $319e236875307eab$var$MessageBlock(_ref) {
  var children = _ref.children,
      ariaLive = _ref['aria-live'];
  return /*#__PURE__*/$9Q8De$react.createElement($9Q8De$VisuallyHidden, {
    role: "log",
    "aria-live": ariaLive,
    "aria-relevant": "additions"
  }, children);
}

export { $319e236875307eab$export$a9b970dcc4ae71a9 as announce, $319e236875307eab$export$d10ae4f68404609a as clearAnnouncer, $319e236875307eab$export$d8686216b8b81b2f as destroyAnnouncer };